import { render, staticRenderFns } from "./DeviceTransfersView.vue?vue&type=template&id=b55d365a&scoped=true&"
import script from "./DeviceTransfersView.vue?vue&type=script&lang=js&"
export * from "./DeviceTransfersView.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTransfersView.vue?vue&type=style&index=0&id=b55d365a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55d365a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b55d365a')) {
      api.createRecord('b55d365a', component.options)
    } else {
      api.reload('b55d365a', component.options)
    }
    module.hot.accept("./DeviceTransfersView.vue?vue&type=template&id=b55d365a&scoped=true&", function () {
      api.rerender('b55d365a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Transfers/DeviceTransfersView.vue"
export default component.exports